module.exports = __webpack_public_path__ + "static/4-4264b63f0034dbf1cd78e816391bfadb.jpg";